module.exports = __webpack_public_path__ + "static/jon-fcc84c9a3e3d71406715ad9c90e0ff24.jpg";